import { Account, Provider } from 'apprise-core/account'
import { accountendpoints } from 'apprise-core/account.ep'
import { useAuthService } from 'apprise-frontend-iam/service'


export const useAccountCalls = () => {

    const service = useAuthService()

    const api = accountendpoints()


    const self = {

        fetchAccount: (username: string) => service.at(api.one(username)).get<Account>()

        ,

        createAccount: (account: Account) => service.at(api.all()).post<Account>(account)

        ,

        updateAccount: (account: Account) => service.at(api.one(account.username)).put<Account>(account)


        ,

        deleteAccount: (username: string) => service.at(api.one(username)).delete()

        ,

        verifyAccount: (username: string) => service.at(api.verifyOne(username)).post<Account>()

        ,

        activateAccount: (username: string) => service.at(api.activateOne(username)).post<Account>()

        ,

        deactivateAccount: (username: string) => service.at(api.suspendOne(username)).post<Account>()

        ,

        deactivateAccounts: (usernames: string[]) => service.at(api.suspendMany()).post<string[]>(usernames)

        ,

        resetAccount: (username: string) => service.at(api.resetOne(username)).post<Account>()

        ,

        fetchProviders: () => service.at(api.providers()).get<Provider[]>()

    }

    return self
}